

















import {Component, Inject, Prop} from "vue-property-decorator";
import {LadingStore} from "@/modules/ladings/store";
import {Lading} from "@/interfaces/entity";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
@Component({
    name: "LadingTableAction"
})
export default class extends mixins(CommonMixin) {
    @Inject({ default: false }) readonly routingEdit!: boolean;
    @Prop({ required: true, type: String })
    readonly ladingId!: string;

    get lading(): Lading {
        return LadingStore.data[this.ladingId];
    }

    set lading(value: Lading) {
        LadingStore.data[this.ladingId] = value;
    }
    async onConfirm() {
        try {
            await LadingStore.deleteLading(this.ladingId);
            this.$message.success("Xóa vận đơn thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa vận đơn thất bại");
        }
    }

    updateLading() {
        if(this.routingEdit) {
            this.$router.push({ name: 'updateFormLadingRouting', params: { id: this.ladingId } });
        } else {
            this.$emit("updateLading", this.ladingId);
        }
    }
}
